/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getContactForm = /* GraphQL */ `
  query GetContactForm($id: ID!) {
    getContactForm(id: $id) {
      id
      firstName
      lastName
      email
      message
      phone
      status
      adminRef
      adminNotes
      adminUpdatedAt
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listContactForms = /* GraphQL */ `
  query ListContactForms(
    $filter: ModelContactFormFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listContactForms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        email
        message
        phone
        status
        adminRef
        adminNotes
        adminUpdatedAt
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComplianceComplains = /* GraphQL */ `
  query GetComplianceComplains($id: ID!) {
    getComplianceComplains(id: $id) {
      id
      userEmail
      fullName
      name
      compCreatedDate
      compUpdatedDate
      dateOfBirth
      isReviewed
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listComplianceComplains = /* GraphQL */ `
  query ListComplianceComplains(
    $filter: ModelComplianceComplainsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComplianceComplains(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userEmail
        fullName
        name
        compCreatedDate
        compUpdatedDate
        dateOfBirth
        isReviewed
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAddFundWallet = /* GraphQL */ `
  query GetAddFundWallet($id: ID!) {
    getAddFundWallet(id: $id) {
      id
      paymentMethod
      amountCAD
      transactionID
      apayloReferenceNumber
      status
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      walletID
      Wallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      requestDate
      completionDate
      adminName
      reason
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAddFundWallets = /* GraphQL */ `
  query ListAddFundWallets(
    $filter: ModelAddFundWalletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAddFundWallets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        paymentMethod
        amountCAD
        transactionID
        apayloReferenceNumber
        status
        userID
        walletID
        requestDate
        completionDate
        adminName
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addFundWalletsByUserID = /* GraphQL */ `
  query AddFundWalletsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAddFundWalletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addFundWalletsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        paymentMethod
        amountCAD
        transactionID
        apayloReferenceNumber
        status
        userID
        walletID
        requestDate
        completionDate
        adminName
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const addFundWalletsByWalletID = /* GraphQL */ `
  query AddFundWalletsByWalletID(
    $walletID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAddFundWalletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    addFundWalletsByWalletID(
      walletID: $walletID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        paymentMethod
        amountCAD
        transactionID
        apayloReferenceNumber
        status
        userID
        walletID
        requestDate
        completionDate
        adminName
        reason
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEFTBankAccount = /* GraphQL */ `
  query GetEFTBankAccount($id: ID!) {
    getEFTBankAccount(id: $id) {
      id
      customerNumber
      customerName
      customerTypeCode
      email
      customerStatus
      customerAccountId
      accountName
      accountNumber
      transitNumber
      institutionNumber
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      Transactions {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEFTBankAccounts = /* GraphQL */ `
  query ListEFTBankAccounts(
    $filter: ModelEFTBankAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEFTBankAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        customerNumber
        customerName
        customerTypeCode
        email
        customerStatus
        customerAccountId
        accountName
        accountNumber
        transitNumber
        institutionNumber
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eFTBankAccountsByUserID = /* GraphQL */ `
  query EFTBankAccountsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEFTBankAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eFTBankAccountsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        customerNumber
        customerName
        customerTypeCode
        email
        customerStatus
        customerAccountId
        accountName
        accountNumber
        transitNumber
        institutionNumber
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRecipient = /* GraphQL */ `
  query GetRecipient($id: ID!) {
    getRecipient(id: $id) {
      id
      firstName
      lastName
      phoneNumber
      email
      recipientDeliveryMethod
      isBusiness
      businessName
      addressState
      addressCity
      addressStreet
      reasonSending
      bankName
      bankBranch
      bankAccountHolderName
      bankAccountNumber
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      Transactions {
        nextToken
        __typename
      }
      isRecipientVerified
      addressCountry
      typeOfRecipient
      isWalletRecipient
      recipientWalletID
      RecipientWallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      addressZipCode
      WalletTransfers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRecipients = /* GraphQL */ `
  query ListRecipients(
    $filter: ModelRecipientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRecipients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        phoneNumber
        email
        recipientDeliveryMethod
        isBusiness
        businessName
        addressState
        addressCity
        addressStreet
        reasonSending
        bankName
        bankBranch
        bankAccountHolderName
        bankAccountNumber
        userID
        isRecipientVerified
        addressCountry
        typeOfRecipient
        isWalletRecipient
        recipientWalletID
        addressZipCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const recipientsByUserID = /* GraphQL */ `
  query RecipientsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecipientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recipientsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        phoneNumber
        email
        recipientDeliveryMethod
        isBusiness
        businessName
        addressState
        addressCity
        addressStreet
        reasonSending
        bankName
        bankBranch
        bankAccountHolderName
        bankAccountNumber
        userID
        isRecipientVerified
        addressCountry
        typeOfRecipient
        isWalletRecipient
        recipientWalletID
        addressZipCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const recipientsByRecipientWalletID = /* GraphQL */ `
  query RecipientsByRecipientWalletID(
    $recipientWalletID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRecipientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    recipientsByRecipientWalletID(
      recipientWalletID: $recipientWalletID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        phoneNumber
        email
        recipientDeliveryMethod
        isBusiness
        businessName
        addressState
        addressCity
        addressStreet
        reasonSending
        bankName
        bankBranch
        bankAccountHolderName
        bankAccountNumber
        userID
        isRecipientVerified
        addressCountry
        typeOfRecipient
        isWalletRecipient
        recipientWalletID
        addressZipCode
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKYBiComply = /* GraphQL */ `
  query GetKYBiComply($id: ID!) {
    getKYBiComply(id: $id) {
      id
      entityId
      entityName
      entityApprovalStatus
      companyName
      registrationNumber
      jurisdictionOfIncorporation
      businessType
      documentStatus
      amlStatus
      reviewStatus
      verifiedByUserName
      verificationTimestamp
      contactEmail
      contactPhoneNumber
      address
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listKYBiComplies = /* GraphQL */ `
  query ListKYBiComplies(
    $filter: ModelKYBiComplyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKYBiComplies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        entityId
        entityName
        entityApprovalStatus
        companyName
        registrationNumber
        jurisdictionOfIncorporation
        businessType
        documentStatus
        amlStatus
        reviewStatus
        verifiedByUserName
        verificationTimestamp
        contactEmail
        contactPhoneNumber
        address
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIcomplyVerificationLogs = /* GraphQL */ `
  query GetIcomplyVerificationLogs($id: ID!) {
    getIcomplyVerificationLogs(id: $id) {
      id
      entityId
      entity
      entityApprovalStatus
      givenName
      middleName
      surname
      scannedDocumentType
      scanDocumentNumber
      phoneNubmber
      email
      approvedByuserName
      approvalTimestamp
      dateOfBirth
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIcomplyVerificationLogs = /* GraphQL */ `
  query ListIcomplyVerificationLogs(
    $filter: ModelIcomplyVerificationLogsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIcomplyVerificationLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        entity
        entityApprovalStatus
        givenName
        middleName
        surname
        scannedDocumentType
        scanDocumentNumber
        phoneNubmber
        email
        approvedByuserName
        approvalTimestamp
        dateOfBirth
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWallet = /* GraphQL */ `
  query GetWallet($id: ID!) {
    getWallet(id: $id) {
      id
      availableBalance
      currency
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      onHoldBalance
      AddFundWallets {
        nextToken
        __typename
      }
      SentWalletTransfers {
        nextToken
        __typename
      }
      ReceivedWalletTransfers {
        nextToken
        __typename
      }
      WalletRecipients {
        nextToken
        __typename
      }
      transactionMinForCAD
      transactionMinForBBD
      transactionMaxForCAD
      transactionMaxForBBD
      version
      WalletAdjustments {
        nextToken
        __typename
      }
      WalletLedgers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWallets = /* GraphQL */ `
  query ListWallets(
    $filter: ModelWalletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWallets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletsByUserID = /* GraphQL */ `
  query WalletsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUserMarkup = /* GraphQL */ `
  query GetUserMarkup($id: ID!) {
    getUserMarkup(id: $id) {
      id
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      walletTransactionFeeCAD
      walletTransactionFeeBBD
      markUpRateCAD
      markUpRateBBD
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserMarkups = /* GraphQL */ `
  query ListUserMarkups(
    $filter: ModelUserMarkupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserMarkups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userID
        walletTransactionFeeCAD
        walletTransactionFeeBBD
        markUpRateCAD
        markUpRateBBD
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userMarkupsByUserID = /* GraphQL */ `
  query UserMarkupsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelUserMarkupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userMarkupsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userID
        walletTransactionFeeCAD
        walletTransactionFeeBBD
        markUpRateCAD
        markUpRateBBD
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCashTransactionRecord = /* GraphQL */ `
  query GetCashTransactionRecord($id: ID!) {
    getCashTransactionRecord(id: $id) {
      id
      adminId
      amount
      cashTransactionType
      walletID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      userID
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCashTransactionRecords = /* GraphQL */ `
  query ListCashTransactionRecords(
    $filter: ModelCashTransactionRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCashTransactionRecords(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        adminId
        amount
        cashTransactionType
        walletID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const cashTransactionRecordsByUserID = /* GraphQL */ `
  query CashTransactionRecordsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCashTransactionRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    cashTransactionRecordsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        adminId
        amount
        cashTransactionType
        walletID
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getIdentification = /* GraphQL */ `
  query GetIdentification($id: ID!) {
    getIdentification(id: $id) {
      id
      varificationResult
      varificationTimeStamp
      userVerificationType
      documentLink
      idNumber
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listIdentifications = /* GraphQL */ `
  query ListIdentifications(
    $filter: ModelIdentificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIdentifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        varificationResult
        varificationTimeStamp
        userVerificationType
        documentLink
        idNumber
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const identificationsByUserID = /* GraphQL */ `
  query IdentificationsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelIdentificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    identificationsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        varificationResult
        varificationTimeStamp
        userVerificationType
        documentLink
        idNumber
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      id
      walletID
      receivedAmount
      sendingAmount
      spotRate
      conversionRateFinal
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      completionDate
      Recipient {
        id
        firstName
        lastName
        phoneNumber
        email
        recipientDeliveryMethod
        isBusiness
        businessName
        addressState
        addressCity
        addressStreet
        reasonSending
        bankName
        bankBranch
        bankAccountHolderName
        bankAccountNumber
        userID
        isRecipientVerified
        addressCountry
        typeOfRecipient
        isWalletRecipient
        recipientWalletID
        addressZipCode
        createdAt
        updatedAt
        __typename
      }
      transactionDate
      message
      recievedAmountMethod
      deliveryMethod
      userID
      recipientID
      recipientFirstName
      recipientLastName
      currencySender
      currencyRecipient
      trackingID
      eftbankaccountID
      EFTBankAccount {
        id
        customerNumber
        customerName
        customerTypeCode
        email
        customerStatus
        customerAccountId
        accountName
        accountNumber
        transitNumber
        institutionNumber
        userID
        createdAt
        updatedAt
        __typename
      }
      transactionStatus
      isRecipientVerified
      adminReferance
      adminNotes
      sourceOfFund
      markupRate
      markupFee
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listTransactions = /* GraphQL */ `
  query ListTransactions(
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTransactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        walletID
        receivedAmount
        sendingAmount
        spotRate
        conversionRateFinal
        completionDate
        transactionDate
        message
        recievedAmountMethod
        deliveryMethod
        userID
        recipientID
        recipientFirstName
        recipientLastName
        currencySender
        currencyRecipient
        trackingID
        eftbankaccountID
        transactionStatus
        isRecipientVerified
        adminReferance
        adminNotes
        sourceOfFund
        markupRate
        markupFee
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const transactionsByUserID = /* GraphQL */ `
  query TransactionsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        receivedAmount
        sendingAmount
        spotRate
        conversionRateFinal
        completionDate
        transactionDate
        message
        recievedAmountMethod
        deliveryMethod
        userID
        recipientID
        recipientFirstName
        recipientLastName
        currencySender
        currencyRecipient
        trackingID
        eftbankaccountID
        transactionStatus
        isRecipientVerified
        adminReferance
        adminNotes
        sourceOfFund
        markupRate
        markupFee
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const transactionsByRecipientID = /* GraphQL */ `
  query TransactionsByRecipientID(
    $recipientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsByRecipientID(
      recipientID: $recipientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        receivedAmount
        sendingAmount
        spotRate
        conversionRateFinal
        completionDate
        transactionDate
        message
        recievedAmountMethod
        deliveryMethod
        userID
        recipientID
        recipientFirstName
        recipientLastName
        currencySender
        currencyRecipient
        trackingID
        eftbankaccountID
        transactionStatus
        isRecipientVerified
        adminReferance
        adminNotes
        sourceOfFund
        markupRate
        markupFee
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const transactionsByEftbankaccountID = /* GraphQL */ `
  query TransactionsByEftbankaccountID(
    $eftbankaccountID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsByEftbankaccountID(
      eftbankaccountID: $eftbankaccountID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        receivedAmount
        sendingAmount
        spotRate
        conversionRateFinal
        completionDate
        transactionDate
        message
        recievedAmountMethod
        deliveryMethod
        userID
        recipientID
        recipientFirstName
        recipientLastName
        currencySender
        currencyRecipient
        trackingID
        eftbankaccountID
        transactionStatus
        isRecipientVerified
        adminReferance
        adminNotes
        sourceOfFund
        markupRate
        markupFee
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWalletTransfer = /* GraphQL */ `
  query GetWalletTransfer($id: ID!) {
    getWalletTransfer(id: $id) {
      id
      senderUserID
      SenderUser {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      senderWalletID
      SenderWallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      sourceCurrency
      sentAmount
      receiverUserID
      ReceiverUser {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      receiverWalletID
      ReceiverWallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      targetCurrency
      receivedAmount
      transferType
      transactionFee
      spotRate
      conversionRateFinal
      markupRate
      markupFee
      status
      transferDate
      completionDate
      message
      referenceID
      adminNotes
      recipientID
      Recipient {
        id
        firstName
        lastName
        phoneNumber
        email
        recipientDeliveryMethod
        isBusiness
        businessName
        addressState
        addressCity
        addressStreet
        reasonSending
        bankName
        bankBranch
        bankAccountHolderName
        bankAccountNumber
        userID
        isRecipientVerified
        addressCountry
        typeOfRecipient
        isWalletRecipient
        recipientWalletID
        addressZipCode
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWalletTransfers = /* GraphQL */ `
  query ListWalletTransfers(
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWalletTransfers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletTransfersBySenderUserID = /* GraphQL */ `
  query WalletTransfersBySenderUserID(
    $senderUserID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletTransfersBySenderUserID(
      senderUserID: $senderUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletTransfersBySenderWalletID = /* GraphQL */ `
  query WalletTransfersBySenderWalletID(
    $senderWalletID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletTransfersBySenderWalletID(
      senderWalletID: $senderWalletID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletTransfersByReceiverUserID = /* GraphQL */ `
  query WalletTransfersByReceiverUserID(
    $receiverUserID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletTransfersByReceiverUserID(
      receiverUserID: $receiverUserID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletTransfersByReceiverWalletID = /* GraphQL */ `
  query WalletTransfersByReceiverWalletID(
    $receiverWalletID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletTransfersByReceiverWalletID(
      receiverWalletID: $receiverWalletID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletTransfersByRecipientID = /* GraphQL */ `
  query WalletTransfersByRecipientID(
    $recipientID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelWalletTransferFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletTransfersByRecipientID(
      recipientID: $recipientID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        senderUserID
        senderWalletID
        sourceCurrency
        sentAmount
        receiverUserID
        receiverWalletID
        targetCurrency
        receivedAmount
        transferType
        transactionFee
        spotRate
        conversionRateFinal
        markupRate
        markupFee
        status
        transferDate
        completionDate
        message
        referenceID
        adminNotes
        recipientID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSupportTicket = /* GraphQL */ `
  query GetSupportTicket($id: ID!) {
    getSupportTicket(id: $id) {
      id
      ticketType
      status
      message
      attachment
      adminId
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSupportTickets = /* GraphQL */ `
  query ListSupportTickets(
    $filter: ModelSupportTicketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSupportTickets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ticketType
        status
        message
        attachment
        adminId
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const supportTicketsByUserID = /* GraphQL */ `
  query SupportTicketsByUserID(
    $userID: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSupportTicketFilterInput
    $limit: Int
    $nextToken: String
  ) {
    supportTicketsByUserID(
      userID: $userID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ticketType
        status
        message
        attachment
        adminId
        userID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdmin = /* GraphQL */ `
  query GetAdmin($id: ID!) {
    getAdmin(id: $id) {
      id
      cADToBBDSpotRate
      bBDToCADSpotRate
      adminMarkUpOnCAD
      adminMarkUpOnBBD
      newUserRecommendDailyRemittanceLimitInCAD
      newUserRecommendWeeklyRemittanceLimitInCAD
      newUserRecommendDailyRemittanceLimitInBBD
      newUserRecommendWeeklyRemittanceLimitInBBD
      finalCADToBBD
      finalBBDToCAD
      monthlyLimit
      thresholdlimit
      walletTransactionFeeCAD
      walletTransactionFeeBBD
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdmins = /* GraphQL */ `
  query ListAdmins(
    $filter: ModelAdminFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdmins(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        cADToBBDSpotRate
        bBDToCADSpotRate
        adminMarkUpOnCAD
        adminMarkUpOnBBD
        newUserRecommendDailyRemittanceLimitInCAD
        newUserRecommendWeeklyRemittanceLimitInCAD
        newUserRecommendDailyRemittanceLimitInBBD
        newUserRecommendWeeklyRemittanceLimitInBBD
        finalCADToBBD
        finalBBDToCAD
        monthlyLimit
        thresholdlimit
        walletTransactionFeeCAD
        walletTransactionFeeBBD
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      dateOfBirth
      email
      phoneNumber
      street
      termsAndConditionsAccepted
      privacyPolicyAcknowledged
      picture
      emailVerified
      indentificationVerified
      userStatus
      Transactions {
        nextToken
        __typename
      }
      Identifications {
        nextToken
        __typename
      }
      Wallets {
        nextToken
        __typename
      }
      CashTransactionRecords {
        nextToken
        __typename
      }
      Recipients {
        nextToken
        __typename
      }
      preferredLanguage
      EFTBankAccounts {
        nextToken
        __typename
      }
      AddFundWallets {
        nextToken
        __typename
      }
      SentWalletTransfers {
        nextToken
        __typename
      }
      ReceivedWalletTransfers {
        nextToken
        __typename
      }
      country
      city
      province
      pincode
      name
      isOrganization
      identificationVerified
      rejectionReason
      isRejected
      dailyRemittanceAmount
      remainingDailyRemittanceAmount
      weeklyRemittanceAmount
      remainingWeeklyRemittanceAmount
      dailyRemittanceAmount
      remainingDailyRemittanceAmount
      weeklyRemittanceAmount
      remainingWeeklyRemittanceAmount
      verificationStatus
      businessName
      businessReferenceNumber
      adminLastUpdatedAt
      icomplyEntityId
      icomplyBusinessId
      SupportTickets {
        nextToken
        __typename
      }
      UserMarkups {
        nextToken
        __typename
      }
      WalletAdjustments {
        nextToken
        __typename
      }
      WalletLedgers {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: AWSEmail!
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAdminUtility = /* GraphQL */ `
  query GetAdminUtility($id: ID!) {
    getAdminUtility(id: $id) {
      id
      interacDepositEmail
      interacReceiveEmailFeatureEnabled
      interacReceiveEmailSubject
      notes
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAdminUtilities = /* GraphQL */ `
  query ListAdminUtilities(
    $filter: ModelAdminUtilityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAdminUtilities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        interacDepositEmail
        interacReceiveEmailFeatureEnabled
        interacReceiveEmailSubject
        notes
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWalletAdjustment = /* GraphQL */ `
  query GetWalletAdjustment($id: ID!) {
    getWalletAdjustment(id: $id) {
      id
      walletID
      Wallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      adminID
      adminName
      direction
      amount
      currency
      balanceBefore
      balanceAfter
      reason
      notes
      referenceID
      status
      adjustmentDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWalletAdjustments = /* GraphQL */ `
  query ListWalletAdjustments(
    $filter: ModelWalletAdjustmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWalletAdjustments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        adminID
        adminName
        direction
        amount
        currency
        balanceBefore
        balanceAfter
        reason
        notes
        referenceID
        status
        adjustmentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletAdjustmentsByWalletIDAndAdjustmentDate = /* GraphQL */ `
  query WalletAdjustmentsByWalletIDAndAdjustmentDate(
    $walletID: ID!
    $adjustmentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletAdjustmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletAdjustmentsByWalletIDAndAdjustmentDate(
      walletID: $walletID
      adjustmentDate: $adjustmentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        adminID
        adminName
        direction
        amount
        currency
        balanceBefore
        balanceAfter
        reason
        notes
        referenceID
        status
        adjustmentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletAdjustmentsByUserIDAndAdjustmentDate = /* GraphQL */ `
  query WalletAdjustmentsByUserIDAndAdjustmentDate(
    $userID: ID!
    $adjustmentDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletAdjustmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletAdjustmentsByUserIDAndAdjustmentDate(
      userID: $userID
      adjustmentDate: $adjustmentDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        adminID
        adminName
        direction
        amount
        currency
        balanceBefore
        balanceAfter
        reason
        notes
        referenceID
        status
        adjustmentDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getWalletLedger = /* GraphQL */ `
  query GetWalletLedger($id: ID!) {
    getWalletLedger(id: $id) {
      id
      walletID
      Wallet {
        id
        availableBalance
        currency
        userID
        onHoldBalance
        transactionMinForCAD
        transactionMinForBBD
        transactionMaxForCAD
        transactionMaxForBBD
        version
        createdAt
        updatedAt
        __typename
      }
      userID
      User {
        id
        firstName
        lastName
        dateOfBirth
        email
        phoneNumber
        street
        termsAndConditionsAccepted
        privacyPolicyAcknowledged
        picture
        emailVerified
        indentificationVerified
        userStatus
        preferredLanguage
        country
        city
        province
        pincode
        name
        isOrganization
        identificationVerified
        rejectionReason
        isRejected
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        dailyRemittanceAmount
        remainingDailyRemittanceAmount
        weeklyRemittanceAmount
        remainingWeeklyRemittanceAmount
        verificationStatus
        businessName
        businessReferenceNumber
        adminLastUpdatedAt
        icomplyEntityId
        icomplyBusinessId
        createdAt
        updatedAt
        __typename
      }
      eventType
      direction
      outcome
      amount
      currency
      availableBalanceBefore
      availableBalanceAfter
      onHoldBalanceBefore
      onHoldBalanceAfter
      actorType
      actorID
      sourceRef
      sourceTable
      sourceID
      referenceID
      notes
      metadata
      eventDate
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listWalletLedgers = /* GraphQL */ `
  query ListWalletLedgers(
    $filter: ModelWalletLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWalletLedgers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        walletID
        userID
        eventType
        direction
        outcome
        amount
        currency
        availableBalanceBefore
        availableBalanceAfter
        onHoldBalanceBefore
        onHoldBalanceAfter
        actorType
        actorID
        sourceRef
        sourceTable
        sourceID
        referenceID
        notes
        metadata
        eventDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletLedgersByWalletIDAndEventDate = /* GraphQL */ `
  query WalletLedgersByWalletIDAndEventDate(
    $walletID: ID!
    $eventDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletLedgersByWalletIDAndEventDate(
      walletID: $walletID
      eventDate: $eventDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        eventType
        direction
        outcome
        amount
        currency
        availableBalanceBefore
        availableBalanceAfter
        onHoldBalanceBefore
        onHoldBalanceAfter
        actorType
        actorID
        sourceRef
        sourceTable
        sourceID
        referenceID
        notes
        metadata
        eventDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletLedgersByUserIDAndEventDate = /* GraphQL */ `
  query WalletLedgersByUserIDAndEventDate(
    $userID: ID!
    $eventDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletLedgersByUserIDAndEventDate(
      userID: $userID
      eventDate: $eventDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        eventType
        direction
        outcome
        amount
        currency
        availableBalanceBefore
        availableBalanceAfter
        onHoldBalanceBefore
        onHoldBalanceAfter
        actorType
        actorID
        sourceRef
        sourceTable
        sourceID
        referenceID
        notes
        metadata
        eventDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletLedgersBySourceRefAndEventDate = /* GraphQL */ `
  query WalletLedgersBySourceRefAndEventDate(
    $sourceRef: String!
    $eventDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletLedgersBySourceRefAndEventDate(
      sourceRef: $sourceRef
      eventDate: $eventDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        eventType
        direction
        outcome
        amount
        currency
        availableBalanceBefore
        availableBalanceAfter
        onHoldBalanceBefore
        onHoldBalanceAfter
        actorType
        actorID
        sourceRef
        sourceTable
        sourceID
        referenceID
        notes
        metadata
        eventDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const walletLedgersBySourceIDAndEventDate = /* GraphQL */ `
  query WalletLedgersBySourceIDAndEventDate(
    $sourceID: ID!
    $eventDate: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWalletLedgerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    walletLedgersBySourceIDAndEventDate(
      sourceID: $sourceID
      eventDate: $eventDate
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        walletID
        userID
        eventType
        direction
        outcome
        amount
        currency
        availableBalanceBefore
        availableBalanceAfter
        onHoldBalanceBefore
        onHoldBalanceAfter
        actorType
        actorID
        sourceRef
        sourceTable
        sourceID
        referenceID
        notes
        metadata
        eventDate
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
